import { CalendarEvent } from 'angular-calendar';
import { addMinutes } from 'date-fns';

import { EventType } from './schedule-event.model';

// Schedule.Lookup_ScheduleEventStatus
enum ScheduleEventStatus {
    DRAFT = 1,
    ACTIVE,
    CANCELLED,
    SCHEDULED_EVENT = 100,
    EVENT_HAPPENED,
    EVENT_DIDNT_HAPPEN,
    UNEXPECTED_EVENT,
}

export interface ScheduleItem {
    scheduledEventId: number;
    actualEventId: number;
    eventStatusID: ScheduleEventStatus;
    eventDate: Date;
    duration: number;
    eventTypeId: EventType;
    attributes: string;
    organizerId: number;
    participantId: number;
    eventName: string;
    eventInitials: string;
    eventStatusInitials: string;
    eventStatusName: string;
    eventStatusColour: string;
    organizerLastName: string;
    performerFirstName: string;
    performerLastName: string;
}

export function calendarEventFromScheduleItemTransformer(
    model: ScheduleItem,
): CalendarEvent<ScheduleItem> {
    const endDate = addMinutes(model.eventDate, model.duration);

    return {
        title: model.eventName,
        start: model.eventDate,
        end: endDate,
        color: {
            primary: model.eventStatusColour,
            secondary: model.eventStatusColour,
        },
        meta: model,
    };
}
